import Skills from './skills/Skills'
const Main = () => {
    return (
        <div>
            <Skills />
        </div>
    );
}

export default Main;